import { useState, useEffect } from 'react';

export default function useStore(store) {
  const [state, setState] = useState(store.getState());

  useEffect(() => store.subscribe(setState), [store]);

  return state;
}
